export default __webpack_public_path__ + "f5e5eeabc3fc52e6d590e5f48366484a.png";